export const CyPlaylistIndex = {
  PlaylistPageHeader: "PlaylistPageHeader",
  PlaylistTitle: "PlaylistTitle",
  ButtonAddPlaylist: "ButtonAddPlaylist",
  ShowAllPlaylistsLink: "ShowAllPlaylistsLink",
} as const;
